import { RemoteDataSource, Settings } from "@/datasources/remote_datasource";
import { Failure } from "@/usecases/repository";

export interface MeusDireitosRequest {
  email: string;
  descricao: string;
}

export interface MeusDireitosResponse {
  id: string;
  status: string;
  mensagem: string;
  dataCriacao: string;
}

class PrivacidadeService {
  private readonly remoteDataSource: RemoteDataSource;

  constructor() {
    this.remoteDataSource = new RemoteDataSource(Settings.urlBase);
  }

  async solicitarMeusDireitos(
    request: MeusDireitosRequest,
  ): Promise<{ success: MeusDireitosResponse } | { failure: Failure }> {
    const errors: string[] = [];

    if (!request.email?.trim()) {
      errors.push("O e-mail é obrigatório.");
    }

    if (!request.descricao?.trim()) {
      errors.push("A descrição do pedido é obrigatória.");
    }

    if (errors.length > 0) {
      return {
        failure: new Failure({ messages: errors }),
      };
    }

    const response = await this.remoteDataSource.post<unknown>({
      endpoint: "/v1/notificacoes/meus-direitos",
      body: {
        chaveSegredo: request.email.trim(),
        descricao: request.descricao.trim(),
      },
      headers: {
        Accept: "application/vnd.data.full.v1+json",
      },
      requiredToken: true,
    });

    if ("failure" in response) {
      return response;
    }

    return { success: response.success.body as MeusDireitosResponse };
  }
}

export const privacidadeService = new PrivacidadeService();
